module.exports = __webpack_public_path__ + "img/monitorbox03.357c2ba9.jpg";